import { IPharmacyImplantStock } from 'app/shared/model/pharmacy-implant-stock.model';
import { IPharmacyImplantBillItem } from 'app/shared/model/pharmacy-implant-bill-item.model';
import { IPharmacyRefundBill } from 'app/shared/model/pharmacy-refund-bill.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { IPharmacyImplantReturnBillItem } from 'app/shared/model/pharmacy-implant-return-bill-item.model';

export interface IPharmacyImplantRefundBillItem {
  id?: string;
  chargedMrp?: number;
  refundPaid?: number;
  refundQty?: number;
  soldQty?: number;
  manufacDate?: number;
  expDate?: number;
  active?: boolean;
  cursor?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  pharmacyStock?: IPharmacyImplantStock | null;
  saleBillItem?: IPharmacyImplantBillItem | null;
  refundBill?: IPharmacyRefundBill | null;
  saleBill?: IPharmacyBill | null;
  returnBill?: IPharmacyReturnBill | null;
  returnItem?: IPharmacyImplantReturnBillItem | null;
}

export const defaultValue: Readonly<IPharmacyImplantRefundBillItem> = {
  active: false,
};
